import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { User, Users, MapPin, CreditCard, ShieldCheck, FileText, Bell, Globe, Lock, HelpCircle, Info, LogOut, ChevronRight, Edit3 } from 'lucide-react';
import { useAppContext } from '../contexts/AppContext';
export function ProfileScreen() {
  const navigate = useNavigate();
  const {
    user,
    setAuthState
  } = useAppContext();
  const handleLogout = () => {
    setAuthState('unauthenticated');
    navigate('/');
  };
  const menuSections = [{
    title: 'Account',
    items: [{
      icon: <User className="w-5 h-5" data-id="element-1299" />,
      label: 'Personal Information',
      route: '#'
    }, {
      icon: <Users className="w-5 h-5" data-id="element-1300" />,
      label: 'Family Members',
      route: '/family'
    }, {
      icon: <MapPin className="w-5 h-5" data-id="element-1301" />,
      label: 'Saved Addresses',
      route: '#'
    }]
  }, {
    title: 'Finance & Health',
    items: [{
      icon: <CreditCard className="w-5 h-5" data-id="element-1302" />,
      label: 'Payment Methods',
      route: '/wallet'
    }, {
      icon: <ShieldCheck className="w-5 h-5" data-id="element-1303" />,
      label: 'Insurance',
      route: '#',
      badge: 'Coming Soon'
    }, {
      icon: <FileText className="w-5 h-5" data-id="element-1304" />,
      label: 'Medical Records',
      route: '/records'
    }]
  }, {
    title: 'Preferences',
    items: [{
      icon: <Bell className="w-5 h-5" data-id="element-1305" />,
      label: 'Notification Settings',
      route: '#'
    }, {
      icon: <Globe className="w-5 h-5" data-id="element-1306" />,
      label: 'Language',
      route: '#',
      value: 'English'
    }, {
      icon: <Lock className="w-5 h-5" data-id="element-1307" />,
      label: 'Privacy & Security',
      route: '#'
    }]
  }, {
    title: 'Support',
    items: [{
      icon: <HelpCircle className="w-5 h-5" data-id="element-1308" />,
      label: 'Help & Support',
      route: '#'
    }, {
      icon: <Info className="w-5 h-5" data-id="element-1309" />,
      label: 'About Whiz',
      route: '#'
    }]
  }];
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="flex flex-col h-full bg-slate-50 pb-20" data-id="element-1310">
      <div className="bg-white px-6 pt-12 pb-6 shadow-sm z-10 sticky top-0" data-id="element-1311">
        <h1 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-1312">Profile</h1>

        <div className="flex items-center gap-4" data-id="element-1313">
          <div className="relative" data-id="element-1314">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold text-2xl" data-id="element-1315">
              {user?.name.charAt(0)}
            </div>
            <button className="absolute bottom-0 right-0 bg-white p-1.5 rounded-full shadow-sm border border-slate-100 text-slate-600 hover:text-blue-600" data-id="element-1316">
              <Edit3 className="w-4 h-4" data-id="element-1317" />
            </button>
          </div>
          <div data-id="element-1318">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-1319">{user?.name}</h2>
            <p className="text-slate-500" data-id="element-1320">{user?.phone}</p>
            <p className="text-sm text-slate-400" data-id="element-1321">{user?.email}</p>
          </div>
        </div>
      </div>

      <div className="px-6 py-6 space-y-8" data-id="element-1322">
        {menuSections.map((section, idx) => <div key={idx} data-id="element-1323">
            <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-3 px-2" data-id="element-1324">
              {section.title}
            </h3>
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden" data-id="element-1325">
              {section.items.map((item, itemIdx) => <button key={itemIdx} onClick={() => item.route !== '#' && navigate(item.route)} className={`w-full flex items-center justify-between p-4 bg-white hover:bg-slate-50 transition-colors ${itemIdx !== section.items.length - 1 ? 'border-b border-slate-100' : ''}`} data-id="element-1326">
                  <div className="flex items-center gap-3 text-slate-700" data-id="element-1327">
                    {item.icon}
                    <span className="font-medium text-sm" data-id="element-1328">{item.label}</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1329">
                    {item.badge && <span className="text-[10px] font-bold uppercase tracking-wider bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full" data-id="element-1330">
                        {item.badge}
                      </span>}
                    {item.value && <span className="text-sm text-slate-400" data-id="element-1331">
                        {item.value}
                      </span>}
                    <ChevronRight className="w-5 h-5 text-slate-400" data-id="element-1332" />
                  </div>
                </button>)}
            </div>
          </div>)}

        <button onClick={handleLogout} className="w-full flex items-center justify-center gap-2 p-4 bg-red-50 text-red-600 rounded-2xl font-semibold hover:bg-red-100 transition-colors" data-id="element-1333">
          <LogOut className="w-5 h-5" data-id="element-1334" />
          Log Out
        </button>

        <div className="text-center pb-6" data-id="element-1335">
          <p className="text-xs text-slate-400" data-id="element-1336">Whiz App Version 1.0.0</p>
        </div>
      </div>
    </motion.div>;
}